import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Modal, Button, Stack, TextField, Checkbox, Typography } from '@mui/material';
import MaskCpfCnpj from './helpers/MaskCpfCnpj';
import { updateGenericData } from './api';
import { cores, labelCampoEscuro } from '../styles/styleUtils';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50vw',
  height: '95vh',
  '@media screen and (max-width: 600px)': {
    width: '50vw', // Width de 100% para telas de celulares
    height: '95vh',
  },
  bgcolor: 'transparent',
  border: `1px solid ${cores.chumbo}`, borderTop: `4px solid ${cores.laranja}`,
  boxShadow: 24,
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  background: `linear-gradient(180deg, ${cores.painelTopo} 0%, ${cores.painelBase} 100%)`,
  alignItems: 'center',
  justifyContent: 'center',
};

// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars
const ModalAddFornecedor = React.forwardRef((props, ref) => {
  const [data, setData] = useState(props.dataSelected);

  const handleChange = (e) => {
    setData({ ...data, [e.target.id]: e.target.value });
  };

  const handleChangeCpf = (e) => {
    const newCpf = e.target.value.replace(/\D/g, '');
    setData({ ...data, cnpj: newCpf });
  };

  const saveData = async () => {
    if (data.cnpj) {
      const newCpf = data.cnpj.replace(/\D/g, '');
      data.cnpj = newCpf;
    }
    await updateGenericData('fornecedor', data);
    props.onConfirm();
  };

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} gap={2}>
        <TextField
          id="razaoSocial"
          label="Razão Social"
          variant="outlined"
          value={data?.razaoSocial}
          onChange={handleChange}
          sx={{ width: '70%', backgroundColor: 'white', ...labelCampoEscuro, mt: 1 }}
        />
        <TextField
          id="nome"
          label="Nome Fantasia"
          variant="outlined"
          value={data?.nome}
          onChange={handleChange}
          sx={{ width: '70%', backgroundColor: 'white', ...labelCampoEscuro, mt: 1 }}
        />
        <MaskCpfCnpj
          id="cnpj"
          label="CNPJ"
          variant="outlined"
          value={data?.cnpj}
          onChange={handleChangeCpf}
          sx={{ width: '70%', backgroundColor: 'white', ...labelCampoEscuro }}
        />

        <Stack direction={'row'} gap={5} alignItems={'left'}>
          <Typography mt={1} sx={{ color: cores.textoClaro }}>Forma Recebimento:</Typography>

          <Stack direction={'row'}>
            <Checkbox
              checked={data?.recebimentoBoleto}
              onChange={() => setData({ ...data, recebimentoBoleto: !data.recebimentoBoleto })}
              inputProps={{ 'aria-label': 'controlled' }}
            sx={{ color: 'rgba(255,255,255,0.7)', '&.Mui-checked': { color: cores.laranja } }}
            />
            <Typography mt={1} sx={{ color: cores.textoClaro }}>Boleto</Typography>
          </Stack>

          <Stack direction={'row'}>
            <Checkbox
              checked={data?.recebimentoPix}
              onChange={() => setData({ ...data, recebimentoPix: !data.recebimentoPix })}
              inputProps={{ 'aria-label': 'controlled' }}
            sx={{ color: 'rgba(255,255,255,0.7)', '&.Mui-checked': { color: cores.laranja } }}
            />
            <Typography mt={1} sx={{ color: cores.textoClaro }}>PIX</Typography>
          </Stack>

          <Stack direction={'row'}>
            <Checkbox
              checked={data?.recebimentoTransferencia}
              onChange={() => setData({ ...data, recebimentoTransferencia: !data.recebimentoTransferencia })}
              inputProps={{ 'aria-label': 'controlled' }}
            sx={{ color: 'rgba(255,255,255,0.7)', '&.Mui-checked': { color: cores.laranja } }}
            />
            <Typography mt={1} sx={{ color: cores.textoClaro }}>Transferência</Typography>
          </Stack>
        </Stack>
        {data.recebimentoPix && (
          <>
            <TextField
              id="chavepix"
              label="Chave PIX"
              variant="outlined"
              value={data?.chavepix}
              onChange={handleChange}
              sx={{ width: '70%', backgroundColor: 'white', ...labelCampoEscuro, mt: 1 }}
            />
            <TextField
              id="tipoChavePix"
              label="Tipo de Chave"
              variant="outlined"
              value={data?.tipoChavePix}
              onChange={handleChange}
              sx={{ width: '70%', backgroundColor: 'white', ...labelCampoEscuro, mt: 1 }}
            />
          </>
        )}

        {data.recebimentoTransferencia && (
          <>
            <TextField
              type={'number'}
              id="numeroBanco"
              label="Numero Banco"
              variant="outlined"
              value={data?.numeroBanco}
              onChange={handleChange}
              sx={{ width: '70%', backgroundColor: 'white', ...labelCampoEscuro, mt: 1 }}
            />
            <TextField
              id="agencia"
              label="Agência"
              variant="outlined"
              value={data?.agencia}
              onChange={handleChange}
              sx={{ width: '70%', backgroundColor: 'white', ...labelCampoEscuro, mt: 1 }}
            />
            <TextField
              id="contaCorrente"
              label="Conta Corrente"
              variant="outlined"
              value={data?.contaCorrente}
              onChange={handleChange}
              sx={{ width: '70%', backgroundColor: 'white', ...labelCampoEscuro, mt: 1 }}
            />
          </>
        )}

        <Stack direction={'row'}>
          <Checkbox
            checked={data?.ativo}
            onChange={() => setData({ ...data, ativo: !data.ativo })}
            inputProps={{ 'aria-label': 'controlled' }}
            sx={{ color: 'rgba(255,255,255,0.7)', '&.Mui-checked': { color: cores.laranja } }}
          />
          <Typography mt={1} sx={{ color: cores.textoClaro }}>Ativo</Typography>
        </Stack>
        <Stack direction={'row'} justifyContent={'space-between'} gap={20} mt={0}>
          <Button variant="outlined" onClick={props.onClose} color="error">
            {' '}
            Cancelar
          </Button>
          <Button variant="contained" color="success" onClick={saveData}>
            Salvar
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
});

ModalAddFornecedor.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default ModalAddFornecedor;